module.exports = __webpack_public_path__ + "img/right-quote.bb1c2105.svg";